import React from 'react';
import { ArticleSection } from './ArticleSection';
import { useCases } from '../../data/articleLists';
export function UseCasesSection() {
  return <ArticleSection id="use-cases" title="Business Use Cases for AI Workflow Automation" data-id="element-134" data-mp="14sg7i6yx7i86">
      <p data-id="element-135" data-mp="1in8v7soys4pu">
        The strongest early wins come from work that is frequent, rules-heavy and currently stitched
        together by people moving information between systems. Across English businesses, these are the
        areas where providers most often start:
      </p>
      <dl className="!mt-6 grid gap-x-10 sm:grid-cols-2" data-id="element-136" data-mp="1njzboh4ol2bs">
        {useCases.map(item => <div key={item.area} className="border-t border-line py-5" data-id="element-137" data-mp="21jqviyhvpcxp">
            <dt className="font-semibold text-ink" data-id="element-138" data-mp="1wlyt3ajly8f9">{item.area}</dt>
            <dd className="mt-1.5 text-[0.975rem] leading-7 text-muted" data-id="element-139" data-mp="1wjm9yu245s0m">{item.examples}</dd>
          </div>)}
      </dl>
      <p data-id="element-140" data-mp="27xsak4hzbcj">
        The pattern is consistent: AI handles interpretation and first drafts, integrations move the data,
        and people review the cases that genuinely need judgement. Starting with one well-understood
        process builds the evidence and internal confidence needed to expand.
      </p>
    </ArticleSection>;
}